import { render, staticRenderFns } from "./noticelist.vue?vue&type=template&id=becbd608&scoped=true"
import script from "./noticelist.vue?vue&type=script&lang=js"
export * from "./noticelist.vue?vue&type=script&lang=js"
import style0 from "./noticelist.vue?vue&type=style&index=0&id=becbd608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8c4e5e0a3a88c7932152ef02627e3518/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becbd608",
  null
  
)

export default component.exports